(function () {
    'use strict';

    angular
        .module('app')
        .controller('oauth_logout', oauth_logout);

    oauth_logout.$inject = ['$state'];

    function oauth_logout($state) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'oauth_logout';
        vm.processing = false;

        vm.logIn = function () {
            vm.processing = true;
            $state.go("layout.home");
        }

        activate();

        function activate() { }
    }
})();
